import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';
import 'rxjs/add/operator/toPromise';
import { global } from '../../models/global';
import { Artworkspecification } from 'src/app/Models/Admin/artworkspecification';

@Injectable({
    providedIn: 'root'
})
export class ArtworksSpecificationService {

    ROOT_URL: string = "";
    constructor(private http: Http) {
        let g: global = new global();
        this.ROOT_URL = g.getApiUrl();
    }

    GetArtworksSpecification(): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'GET',
            url: this.ROOT_URL + "/api/ArtworksSpecification/ArtworksSpecification?userID=" + userID,
            headers: headers
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }

    downloadArtworkExcel(): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId')
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/ArtworksSpecification/DownloadArtworkExcel",
            headers: headers,
            body: _body,
            responseType: ResponseContentType.Blob
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                var blob = new Blob([res.blob()], { type: 'xlsx' })
                return blob;
            });
    }


    uploadDocument(documents : File): Observable<any> {
        const formData = new FormData();
        formData.append("file", documents);
        formData.append("UserId", localStorage.getItem('mcmt_userId'));

        let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions : RequestOptions = new RequestOptions({
            headers : headers
        })
        return this.http.post(this.ROOT_URL + "/api/ArtworksSpecification/UploadArtworkSpecification", formData, requestoptions)
            .map((res : Response) => {
                return res.json();
            });
    }


    updateArtworksSpecification(updateArtwork : Artworkspecification[]): Observable<any> {
        let _body = {
            "UserID":localStorage.getItem('mcmt_userId'),
            "UpdateArtwork":updateArtwork
            }
            
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/ArtworksSpecification/UpdateArtworksSpecification",
            headers: headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }


    getArtworksSpecificationDropDown(): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'GET',
            url: this.ROOT_URL + "/api/ArtworksSpecification/ArtworksSpecificationDropDown?userID=" + userID,
            headers: headers
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }

    updateOtherBrands(portfolio, brand, brandManager): Observable<any> {
        let _body = {
            "UserID" :localStorage.getItem('mcmt_userId'),
            "Portfolio" :portfolio,
            "Brand" : brand,
            "BrandManager" : brandManager
            }
            
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/ArtworksSpecification/UpdateOtherBrands",
            headers: headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }
}
